var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barcode-scanner"},[_c('video',{ref:"video",staticClass:"barcode-scanner-video",attrs:{"playsinline":"","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }